import { render, staticRenderFns } from "./pointForm.vue?vue&type=template&id=ff6c8af2&scoped=true&"
import script from "./pointForm.vue?vue&type=script&lang=js&"
export * from "./pointForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6c8af2",
  null
  
)

export default component.exports